import type { DenialPreventionCriterion } from "../types/DenialPrevention";
import type { ArasScoreRowId } from "./aras-score-legend-lines";
import type { ArasScoreBand, ArasScoreCategoryRow } from "./aras-score-types";

/** Dot/score color band from numeric score (1 = low / red … 3 = green). */
export function arasBandFromScore(score: number): ArasScoreBand {
  if (score <= 1) return "red";
  if (score === 2) return "orange";
  return "green";
}

const TITLE_TO_LEGEND_ROW: Record<string, ArasScoreRowId> = {
  "medical complexity": "medical-complexity",
  "therapy needs": "therapy-needs",
  "functional tolerance": "functional-tolerance",
  "baseline change": "baseline-change",
  diagnosis: "diagnosis",
};

/**
 * When the API criterion title matches a known ARAS category, score tooltips use that row’s legend.
 */
export function criterionTitleToLegendRowId(
  title: string,
): ArasScoreRowId | undefined {
  const key = title.trim().toLowerCase();
  return TITLE_TO_LEGEND_ROW[key];
}

export function mapDenialPreventionCriteriaToRows(
  criteria: DenialPreventionCriterion[],
): ArasScoreCategoryRow[] {
  return criteria.map((c) => {
    const legendRowId = criterionTitleToLegendRowId(c.criteria);
    return {
      id: String(c.id),
      label: c.criteria,
      points: c.score,
      band: arasBandFromScore(c.score),
      expandedDetail: c.reasoning,
      ...(legendRowId != null
        ? { legendRowId }
        : { scoreLegendTooltip: false as const }),
    };
  });
}
